import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDotIndicator = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 8,
	height: 8,
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 4,
		cy: 4,
		r: 4,
		fill: "#DDB847"
	})
});
export default SvgDotIndicator;
